import Vue from 'vue'
import Router from 'vue-router'
import Home from './../views/Home.vue'
import Guard from './../middlewares/Guard'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/reports',
      name: 'reports',
      component: () => import(/* webpackChunkName: "reports" */ './../views/Reports.vue'),
      redirect: { name: 'indexReports' },
      beforeEnter: Guard.pro,
      meta: {
        layout: 'default'
      },
      children: [
        {
          path: 'all',
          name: 'indexReports',
          meta: {
            layout: 'default'
          },
          component: () => import(/* webpackChunkName: "reports" */ './../views/reports/ListAllReports.vue'),
        },
        {
          path: 'finished',
          name: 'finishedReports',
          meta: {
            layout: 'default'
          },
          component: () => import(/* webpackChunkName: "reports" */ './../views/reports/ListFinishedReports.vue'),
        },
        {
          path: 'pending',
          name: 'pendingReports',
          meta: {
            layout: 'default'
          },
          component: () => import(/* webpackChunkName: "reports" */ './../views/reports/ListPendingFirstReports.vue'),
        },
        {
          path: 'return',
          name: 'returnReports',
          meta: {
            layout: 'default'
          },
          component: () => import(/* webpackChunkName: "reports" */ './../views/reports/ListPendingSecondReports.vue'),
        },
        {
          path: ':id',
          name: 'singleReport',
          meta: {
            layout: 'default'
          },
          component: () => import(/* webpackChunkName: "report" */ './../views/report/SingleReport.vue')
        }
      ]
    },
    {
      path: '/fleet',
      name: 'fleet',
      beforeEnter: Guard.pro,
      meta: {
        layout: 'default'
      },
      component: () => import(/* webpackChunkName: "fleet" */ './../views/Fleet.vue'),
      redirect: { name: 'indexItems' },
      children: [
        {
          path: 'all',
          name: 'indexItems',
          meta: {
            layout: 'default'
          },
          component: () => import(/* webpackChunkName: "fleet-index" */ './../views/items/ListAllItems.vue'),
        },
        {
          path: 'item-import-help',
          name: 'itemImportHelp',
          meta: {
            layout: 'default'
          },
          component: () => import(/* webpackChunkName: "fleet-help" */ './../views/items/ItemImportHelp.vue'),
        },
        {
          path: ':id/reports',
          name: 'itemReports',
          meta: {
            layout: 'default'
          },
          component: () => import(/* webpackChunkName: "report" */ './../views/items/ListAllReports.vue')
        }
      ]
    },
    {
      path: '/missions',
      name: 'missions',
      beforeEnter: Guard.pro,
      meta: {
        layout: 'default'
      },
      component: () => import(/* webpackChunkName: "missions" */ './../views/Missions.vue'),
      redirect: { name: 'createMission' },
      children: [
        {
          path: 'all',
          name: 'indexMissions',
          meta: {
            layout: 'default'
          },
          component: () => import(/* webpackChunkName: "missions-index" */ './../views/missions/ListAllMissions.vue'),
        },
        {
          path: 'create',
          name: 'createMission',
          meta: {
            layout: 'default'
          },
          component: () => import(/* webpackChunkName: "mission-create" */ './../views/missions/CreateMission.vue'),
        },
      ],
    },
    {
      path: '/profile',
      name: 'profile',
      beforeEnter: Guard.pro,
      meta: {
        layout: 'default'
      },
      component: () => import(/* webpackChunkName: "profile" */ './../views/Profile.vue'),
    },
    {
      path: '/company',
      name: 'company',
      component: () => import(/* webpackChunkName: "company" */ './../views/Company.vue'),
      redirect: { name: 'teamCompany' },
      beforeEnter: Guard.pro,
      meta: {
        layout: 'default'
      },
      children: [
        {
          path: 'team',
          name: 'teamCompany',
          meta: {
            layout: 'default'
          },
          component: () => import(/* webpackChunkName: "company" */ './../views/company/TeamCompany.vue')
        },
        {
          path: 'affilations',
          name: 'affiliationsCompany',
          meta: {
            layout: 'default'
          },
          component: () => import(/* webpackChunkName: "company" */ './../views/company/AffiliationsCompany.vue')
        },
        {
          path: 'logo',
          name: 'logoCompany',
          meta: {
            layout: 'default'
          },
          component: () => import(/* webpackChunkName: "company" */ './../views/company/LogoCompany.vue')
        },
        {
          path: 'webhook',
          name: 'webhookCompany',
          meta: {
            layout: 'default'
          },
          component: () => import(/* webpackChunkName: "company" */ './../views/company/WebhookCompany.vue')
        }
      ]
    },
    {
      path: '/create',
      name: 'create',
      meta: {
        layout: 'default'
      },
      beforeEnter: Guard.pro,
      component: () => import(/* webpackChunkName: "create" */ './../views/Create.vue'),
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        layout: 'public'
      },
      beforeEnter: Guard.guest,
      component: () => import(/* webpackChunkName: "login" */ './../views/Login.vue'),
    },
    {
      path: '/trial',
      name: 'trial',
      meta: {
        layout: 'public'
      },
      component: () => import(/* webpackChunkName: "trial" */ './../views/Trial.vue'),
    },
    {
      path: '/signup',
      name: 'signup',
      meta: {
        layout: 'public'
      },
      beforeEnter: Guard.guest,
      component: () => import(/* webpackChunkName: "signup" */ './../views/SignUp.vue'),
    },
    {
      path: '/lost-password',
      name: 'lostPassword',
      meta: {
        layout: 'public'
      },
      beforeEnter: Guard.guest,
      component: () => import(/* webpackChunkName: "lost-password" */ './../views/LostPassword.vue'),
    },
    {
      path: '/regular',
      name: 'regular',
      meta: {
        layout: 'public'
      },
      beforeEnter: Guard.regular,
      component: () => import(/* webpackChunkName: "regular" */ './../views/Regular.vue'),
    },
    {
      path: '/download-app',
      name: 'download-app',
      meta: {
        layout: 'public'
      },
      beforeEnter: Guard.regular,
      component: () => import(/* webpackChunkName: "download-app" */ './../views/regular/DownloadApp.vue'),
    },
    {
      path: '/trial-expired',
      name: 'trial-expired',
      meta: {
        layout: 'public'
      },
      beforeEnter: Guard.regular,
      component: () => import(/* webpackChunkName: "trial-expired" */ './../views/regular/TrialExpired.vue'),
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        layout: 'public'
      },
      beforeEnter: Guard.auth
    },
    // {
    //   path: '*',
    //   beforeEnter:   //   redirect: { name: 'home' } && Guard.auth
    // }
  ],
})

if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
  router.addRoutes(
    [
      {
        path: '/sandbox',
        name: 'sandbox',
        meta: {
          layout: 'default'
        },
        component: () => import(/* webpackChunkName: "sandbox" */ './../views/Sandbox.vue'),
      }
    ]
  )
}

export default router
